import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconInfoSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9 4C9 4.55228 8.55229 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55229 3 9 3.44772 9 4ZM6 6C5.44772 6 5 6.44772 5 7C5 7.55228 5.44772 8 6 8H7V12C7 12.5523 7.44772 13 8 13C8.55228 13 9 12.5523 9 12V6H6Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
